import { Flex, Modal, Spin } from "antd";

export const LoaderFullscreen = () => {
  return (
    <Modal
      open
      centered
      footer={null}
      closable={false}
      modalRender={() => (
        <Flex justify="center">
          <Spin size="large" styles={{ indicator: { color: "white" } }} />
        </Flex>
      )}
      styles={{ container: { background: "transparent", boxShadow: "none" } }}
    />
  );
};
